export default __webpack_public_path__ + "static/media/visa_card.0c43e067.png";